import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Bridge: tenant state still lives in legacy Redux. This import will be
// removed once the application slice is migrated to the new store.
import { getApplication } from '../../../legacyfrontend/redux/actions/application-actions';

export function useClientTenantSync(): void {
  const dispatch = useDispatch();
  const webFromStore: string = useSelector((state: any) => state?.applicationState?.web || '');
  const lastSyncedHostname = useRef<string | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const currentHostname = window.location.hostname;

    if (lastSyncedHostname.current === currentHostname) return;
    if (webFromStore === currentHostname) return;
    if (!currentHostname) return;

    lastSyncedHostname.current = currentHostname;

    // getApplication rethrows on API failure; catch to avoid unhandled rejection
    void Promise.resolve(dispatch(getApplication(currentHostname) as any)).catch((err: unknown) => {
      // eslint-disable-next-line no-console
      console.error('[useClientTenantSync] getApplication failed:', err);
    });
  }, [webFromStore, dispatch]);
}
